import { Box, Container, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { APIS } from '../../../lib/constants/apis';
import { T, enumT, getFieldNamefromDataPath, getLabelFromDataPath, removeDataKeys, removeNullDeep } from '../../../utils/helper';
import { get } from 'lodash';
import GetRecords from '../../../lib/api/GetRecords';
import { deDE, DataGridPremium, LicenseInfo, GridToolbar } from '@mui/x-data-grid-premium';
import { DisplayDateTime } from '../../../utils/formats';
import { useLocation, useNavigate } from 'react-router-dom';
import { MUIX_LICENSE } from '../../../lib/constants/constant';

import Schema from '../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import { getLocalstorageToken } from '../../../context/AuthHelper';
const ZP = Schema.attributes;

LicenseInfo.setLicenseKey(MUIX_LICENSE);

function MeineAntraege() {
	const location = useLocation();
	const navigate = useNavigate();
	const [data, setData] = useState<any[]>([]);

	const columns = [
		{ field: 'id', headerName: 'ID' },
		{
			field: getFieldNamefromDataPath(ZP.Allgemein_Projekttitel.path),
			headerName: getLabelFromDataPath(ZP.Allgemein_Projekttitel.path),
			flex: 1,
		},
		{
			field: getFieldNamefromDataPath(ZP.Antragsstatus_Antragsstatus.path),
			headerName: getLabelFromDataPath(ZP.Antragsstatus_Antragsstatus.path),
			flex: 1,
		},
		{
			field: getFieldNamefromDataPath(ZP.Allgemein_Projektnummer.path),
			headerName: getLabelFromDataPath(ZP.Allgemein_Projektnummer.path),
			flex: 1,
		},
		{
			field: getFieldNamefromDataPath(ZP.Allgemein_Typ.path),
			headerName: getLabelFromDataPath(ZP.Allgemein_Typ.path),
			flex: 1,
		},
		{
			field: getFieldNamefromDataPath(ZP.Allgemein_Eingereicht_Am.path),
			headerName: getLabelFromDataPath(ZP.Allgemein_Eingereicht_Am.path),
			flex: 1,
		},
	];

	useEffect(() => {
		const fetch = async () => {
			const filter = {
				AN_Organisation: { id: { $eq: get(getLocalstorageToken(), 'organisationId') } },
			};
			let res = await GetRecords(APIS.Zuwendungsantrag, [], filter, [{ updatedAt: 'desc' }]);
			const transformedData = removeNullDeep(removeDataKeys(get(res, 'data', []))).map((ele: Record<string, any>) => {
				return {
					id: get(ele, 'id'),
					[getFieldNamefromDataPath(ZP.Allgemein_Projekttitel.path)]: enumT(get(ele, ZP.Allgemein_Projekttitel.path)),
					[getFieldNamefromDataPath(ZP.Allgemein_Projektnummer.path)]: enumT(get(ele, ZP.Allgemein_Projektnummer.path)),
					[getFieldNamefromDataPath(ZP.Antragsstatus_Antragsstatus.path)]: enumT(
						get(ele, ZP.Antragsstatus_Antragsstatus.path),
					),
					[getFieldNamefromDataPath(ZP.Allgemein_Typ.path)]: T(get(ele, ZP.Allgemein_Typ.path)),
					[getFieldNamefromDataPath(ZP.Allgemein_Eingereicht_Am.path)]: DisplayDateTime(
						get(ele, ZP.Allgemein_Eingereicht_Am.path, ''),
					),
					[getFieldNamefromDataPath(ZP.Allgemein_Projektnummer.path)]: T(get(ele, ZP.Allgemein_Projektnummer.path)),
				};
			});
			setData(transformedData);
		};

		fetch();
	}, []);

	return (
		<Container>
			<Typography variant="h3"> Meine Anträge</Typography>
			<Box sx={{ mt: '2rem'}}>
				<DataGridPremium
					autoHeight
					rows={data}
					columns={columns}
					onRowClick={(param) => navigate(`/meine-antraege/foerderung-uebersicht/${param.id}`)}
					initialState={{
						filter: {
							filterModel: {
								items: [get(location, 'state.filter', {})],
							},
						},
					}}
					slots={{ toolbar: GridToolbar }}
					localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
				/>
			</Box>
		</Container>
	);
}

export default MeineAntraege;
